<template>
  <div>
    <div class="container">
      <div class="col-md-9 m-auto alert alert-info bg-white">
        <h3 class="md-toolbar md-elevation-4 md-info text-light">
          {{ $t("stopwatch") }}
          <helpWidget
            v-if="this.attributes.help_img || this.attributes.help"
            class="pl-3 float-right"
            :help="help_key"
            :help_img="
              this.attributes.help_img
                ? `${this.IREALCONFIG.static_ressources}/${this.attributes.help_img}.png`
                : ''
            "
            :help_style="this.attributes.help_style"
          ></helpWidget>
        </h3>
        <div class="container m-auto">
          <div class="row">
            <h3 class="m-auto text-center" style="font-size: 2vw">
              {{ display }}.{{ displayms }}
            </h3>
          </div>
          <div class="row justify-content-md-center">
            <md-button
              class="col-md-3 md-info mt-3"
              @click="start"
              v-if="!isStarted"
              >Start <md-icon>timer</md-icon></md-button
            >
            <md-button class="col-md-3 md-info mt-3" @click="pause" v-else
              >Pause <md-icon>pause</md-icon></md-button
            >
            <md-button
              class="col-md-3 md-info mt-3"
              @click="stop"
              v-if="!isStopped"
              >{{ tx(`${attributes.label_reset}`) }}
              <md-icon>replay</md-icon></md-button
            >
          </div>
        </div>
      </div>
    </div>
    <!--
  --></div>
</template>

<script>
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
//ref: https://vuejsexamples.com/a-simple-yet-flexible-timer-stopwatch-made-as-a-showcase-with-nuxt-js-vue/
export default {
  name: "chronometer-component",
  mixins: [inputComponentMixin],
  data() {
    return {
      title: "Timer",
      display: "00:00:00",
      displayms: "000",
      d: 0,
      h: 0,
      m: 0,
      s: 0,
      percentage: 0,
      defaultSeconds: 0,
      isStarted: false,
      isStopped: true,
      countingUp: true,
      targetTimestamp: 0,
      pausedDifference: 0,
      interval:null,
    };
  },
  async mounted() {
    // put a wording according to the experience and linked to the i18n.
    //we start with the action start
    this.state = this.tx(`${this.attributes.label_start}`);
  },
  computed: {
    //format the time which is given in milliseconds
    formattedElapsedTime() {
      let hour = Math.floor((this.elapsedTime / (1000 * 60 * 60)) % 24);
      let minute = Math.floor((this.elapsedTime / (1000 * 60)) % 60);
      let second = Math.floor((this.elapsedTime / 1000) % 60);
      let ms = Math.floor((this.elapsedTime % 1000) / 100);
      hour = hour < 10 ? "0" + hour : hour;
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;

      const utc = hour + ":" + minute + ":" + second + ":" + ms;
      return utc;
    },
  },
  methods: {
    start() {
      let nowTimestamp = Date.now();
      let targetTime = this.defaultSeconds;
      if (this.pausedDifference) {
        targetTime = this.pausedDifference;
        this.pausedDifference = 0;
      }
      if (this.countingUp) this.targetTimestamp = nowTimestamp - targetTime;
      else this.targetTimestamp = nowTimestamp + targetTime;
      this.interval = setInterval(() => {
        if (!this.countingUp && this.targetTimestamp - Date.now() < 1) {
          this.stop();
          this.updateDisplay(0);
        } else this.updateDisplay();
      }, 10);
      this.isStarted = true;
      this.isStopped = false;
    },
    pause() {
      let nowTimestamp = Date.now();
      this.pausedDifference = Math.abs(this.targetTimestamp - nowTimestamp);
      clearInterval(this.interval);
      this.updateDisplay();
      this.isStarted = false;
    },
    stop() {
      if (this.isStarted) this.pause();
      this.reset();
      this.updateDisplay();
      this.isStopped = true;
    },
    reset() {
      let nowTimestamp = Date.now();
      if (this.countingUp)
        this.targetTimestamp = nowTimestamp - this.defaultSeconds;
      else this.targetTimestamp = nowTimestamp + this.defaultSeconds;
      this.pausedDifference = 0;
    },
    updateDisplay(targetTime) {
      // Update both display (hh:mm:ss and miliseconds)
      let nowTimestamp = Date.now();
      if (targetTime !== undefined) {
        if (this.countingUp) this.targetTimestamp = nowTimestamp - targetTime;
        else this.targetTimestamp = nowTimestamp + targetTime;
      }
      const s = Math.abs(Date.now() - this.targetTimestamp) / 1000;
      this.ms = Math.floor((s % 1) * 1000);
      this.s = Math.floor(s % 60);
      this.m = Math.floor(s / 60) % 60;
      this.h = Math.floor(s / 3600) % 24;
      this.d = Math.floor(s / 86400);
      let display = this.s.toString().padStart(2, "0");
      display = this.m.toString().padStart(2, "0") + ":" + display;
      display = this.h.toString().padStart(2, "0") + ":" + display;
      if (this.d) display = this.d.toString().padStart(2, "0") + ":" + display;
      this.display = display;
      this.displayms = ("000" + this.ms).slice(-3);
      if (!this.countingUp && this.defaultSeconds) {
        this.percentage = (s * 1000) / this.defaultSeconds;
      }
      // console.log(display)
    },
  },
};
</script>
